import { useEffect, useState } from "react";
import { BaseNodeSearchTabProps } from "../..";
import { SearchKnownSitesPayload } from "../../../../../../../../../../datasources/api-client/data-contracts";
import { SearchCodeMap } from "./SearchCodeMap";

type StandardSearchCode = Extract<keyof SearchKnownSitesPayload, "unlocode" | "iata" | "icao" | "wpi">;
type StandardCodeTabProps = BaseNodeSearchTabProps & { searchCode: StandardSearchCode; debounceTime?: number };
export const StandardCodeTab = ({
	searchCode,
	onSearch,
	onResetResults,
	onSelectNode,
	loading,
	nodes,
	debounceTime = 500,
}: StandardCodeTabProps) => {
	const [code, setCode] = useState("");
	useEffect(() => {
		if (!code) {
			onResetResults();
			return;
		}
		const timer = window.setTimeout(() => {
			const payload = { [searchCode]: code, mode: "standard" } as SearchKnownSitesPayload;
			void onSearch(payload);
		}, debounceTime);
		return () => {
			window.clearTimeout(timer);
		};
	}, [code, searchCode, debounceTime]);
	return (
		<SearchCodeMap
			id={`${searchCode}-code`}
			code={code}
			onChange={setCode}
			loading={loading}
			nodes={nodes}
			onSelectNode={onSelectNode}
		/>
	);
};
